// extracted by mini-css-extract-plugin
export default {"modal":"PressPopup_modal__Tfkxi","heading":"PressPopup_heading__Ybkvt","success-msg":"PressPopup_success-msg__fh8jm"};